import PropTypes from 'prop-types';
import React from 'react';

import CapitalizeFirstWord from 'components/text_editor/plugins/capitalize_first_word';
import CapitalizeI from 'components/text_editor/plugins/capitalize_i';
import Lists from 'components/text_editor/plugins/lists';
import Placeholders, { useFocusFirstPlaceholder } from 'components/text_editor/plugins/placeholders';
import QuoteBlocks from 'components/text_editor/plugins/quote_blocks';
import RichText from 'components/text_editor/plugins/rich_text';
import TextEditor, { getEditorProps, useEditorRef, usePlugins } from 'components/text_editor';
import { useToggleAnswerPanel } from '../plugins/toggle_answer_panel';

export default function RichTextEditor(props) {
  const { onChange } = props;
  const editorRef = useEditorRef(props.editorRef);
  useFocusFirstPlaceholder(editorRef.current, onChange);

  const toggleAnswerPanel = useToggleAnswerPanel();

  const plugins = usePlugins(() => [
    CapitalizeI(),
    CapitalizeFirstWord(),
    RichText({ onChange }),
    Lists(),
    // commenting out inline links for now for now because slate decorations don't play well with spellcheck
    // InlineLinks(),
    Placeholders(),
    QuoteBlocks(),
    toggleAnswerPanel,
    ...props.plugins,
  ]);

  const editorProps = getEditorProps(props);
  return <TextEditor {...editorProps} editorRef={editorRef} plugins={plugins} />;
}

RichTextEditor.defaultProps = {
  plugins: [],
};

RichTextEditor.propTypes = {
  editorRef: PropTypes.shape({ current: PropTypes.any }),
  onChange: PropTypes.func.isRequired,
  plugins: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/composer/editors/rich_text.jsx